import moment from 'moment';
import { useState } from 'react';
import { ChangeAlertCallbackType } from '../../../Root';
import { AccountCircle } from '@mui/icons-material';
import { Box } from "@mui/material";
import { scvStatus, scvAbeaStatus, scvProductStatus } from '../../../../util/DataObject';
moment.locale('es');

export const useSingleView = (changeAlert: ChangeAlertCallbackType) => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const [tabActive, setTabActive] = useState('03_trans_info');

    const status = (name, value, key) => {
        return (
            <Box mt={3}>
                {scvStatus.map((item) => {
                    return item.key === key &&
                    <Box display={"flex"} key={key}>
                        <Box width={'45%'} >
                            <Box width={'fit-content'} sx={{backgroundColor: item.color}} fontWeight={700} color={'#fff'} p={1}>{name}</Box>
                        </Box>
                        <Box py={1}>{value || 'N/A'}</Box>
                    </Box>
                })}
            </Box>
        )
    }

    const sectionOne = [
        { title: 'Información general', sectionName: '01_gral_info', icon: <AccountCircle sx={{ marginRight: 1 }} /> },
    ]
    const sectionTwo = [
        { title: '02_product_info', sectionName: 'albo' },
    ]
    const sectionThree = [
        { title: '02_product_info', sectionName: 'abea' },
        { title: '02_product_info', sectionName: 'albit' },
    ]

    const columns = {
        '01_gral_info': [
            { key: 'bdate', type: 'dateLarge', name: 'Fecha de nacimiento'},
            { key: 'gender', name: 'Género'},
            { key: 'nationality', name: 'Nacionalidad'},
            { key: 'address_shipping', name: 'CP/Localidad/Estado'},
        ],
        'albo': [
            { key: 'albo_status', name: 'Estatus albo', type: 'element', element: status, getData: true},
            { key: 'albo_first_funding', type: 'date', name: 'Cliente desde'},
            { key: 'albo_type', name: 'Tipo de Cuenta'},
            { key: 'albo_account_level_original', name: 'Nivel de cuenta original'},
            { key: 'albo_account_level', name: 'Nivel de cuenta actual'},
            { key: 'albo_employer', name: 'Empleador'},
        ],
        'abea': [
            { key: 'abea_status', name: 'Estatus abea', type: 'element', element: status, getData: true},
            { key: 'abea_date', type: 'date', name: 'Cliente desde'},
            { key: 'abea_loan_status', name: 'Estatus último crédito'},
        ],
        'albit': [
            { key: 'albit_status', name: 'Estatus albit', type: 'element', element: status, getData: true},
            { key: 'albit_date', type: 'date', name: 'Cliente desde'},
            { key: 'albit_coins', name: 'Monedas con saldo'},
        ],
        'cards': [
            { key: 'albo_virtual_card', name: 'Estatus tarjeta física'},
            { key: 'albo_phys_card', name: 'Estatus tarjeta virtual'},
        ],
        '03_trans_info': [
            { key: 'last_login', type: 'timeDate', name: 'Último login'},
            { key: 'last_tx', type: 'timeDate', name: 'Última transacción'},
            { key: 'last_cp', type: 'timeDate', name: 'Último pago con tarjeta'},
            { key: 'cp_category', name: 'Categoría Card Payments'},
            { key: 'monthly_tx', name: 'Transacciones mensuales promedio'},
        ],
        '04_balance': [
            { key: 'balance', name: 'Saldo actual'},
            { key: 'avg_monthly_balance', name: 'Saldo mensual promedio'},
            { key: 'num_spaces', name: 'Espacios con saldo'},
        ]
    }
    
    const tabs = [
        { name: '03_trans_info', title: 'Información transaccional' },
        { name: '04_balance', title: 'Balance' },
    ];

    const saveData = async (result) => {
        setLoading(true);    
        if(result.content['02_product_info']['albit_coins']){
            var coins = result.content['02_product_info']['albit_coins'];
            var words = coins.split('|')
            for (let i = 0; i < words.length; i++) {
                words[i] = words[i][0].toUpperCase() + words[i].substr(1);
            }
            result.content['02_product_info']['albit_coins'] = words.join(", ");
        }
        if(result.content['02_product_info']['abea_status']){
            var abeaStatus = result.content['02_product_info']['abea_status'];
            var resultAbea = scvProductStatus.filter((s) => s.name === abeaStatus);
            result.content['02_product_info']['abea_status'] = resultAbea[0] ? resultAbea[0]["title"] : null;
        }
        if(result.content['02_product_info']['albit_status']){
            var albitStatus = result.content['02_product_info']['albit_status'];
            var resultAlbit = scvProductStatus.filter((s) => s.name === albitStatus);
            result.content['02_product_info']['albit_status'] =  resultAlbit[0] ? resultAlbit[0]["title"] : null;
        }
        if(result.content['02_product_info']['abea_loan_status']){
            var loanStatus = result.content['02_product_info']['abea_loan_status'];
            var resultLoan = scvAbeaStatus.filter((s) => s.name === loanStatus);
            result.content['02_product_info']['abea_loan_status'] = resultLoan[0] ? resultLoan[0]["title"] : null;
        }
        setData(result.content);
        setLoading(false);
    };

    const changeTab = (tab: string) => {
        setTabActive(tab);
    };
    function findActiveTab(item) { 
        return item.name === tabActive;
    };

    return { data, columns, sectionOne, sectionTwo, sectionThree, loading, tabs, tabActive, saveData, changeTab, findActiveTab, status }
}
